// extracted by mini-css-extract-plugin
module.exports = {"editOrderModal":"review-order-edit-modal__editOrderModal___2_V48","editInput":"review-order-edit-modal__editInput___3Eek_"};